import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import Sidebar from './SideBar';
import useAuthRedirect from './Componentes/auth';
import { generarOrdenCompraPDF } from './Documentos/OrdenCompraPDF';
import { formatRemuneracion } from './Validations/TrabajadoresValidation';
import { formatearRutEnTiempoReal, validarRut } from './Componentes/rutUtils';
import config from './Componentes/config';
import moment from 'moment';
import Swal from 'sweetalert2';
import Axios from 'axios';
import { registrarLog } from './Componentes/logService';
import ModalFactura from './Modals/ModalFactura';
import ModalComprobantePago from './Modals/ModalComprobantePago';
import './ccss/OrdenCompras.css';
import { getEmpresaByCodigo } from './Componentes/empresasConfig';

const cardImages = {
    DAFA: "/img/dafaLogo.png",
    FUGA: "/img/fugarLogo.png",
    INVE: "/img/idafaLogo.png",
    TRAN: "/img/extasisLogo.png",
    NIDI: "/img/nidiamLogo.png"
};

function OrdenCompras() {
    useAuthRedirect();
    const [cookies] = useCookies(['selectedCard']);
    const [cookiesEmpresa] = useCookies(['idEmpresa']);
    const imageUrl = cardImages[cookies.selectedCard];

    // Estados para el colapso del sidebar
    const [isComponentsCollapsed, setIsComponentsCollapsed] = useState(true);
    const [isUtilitiesCollapsed, setIsUtilitiesCollapsed] = useState(true);
    const [isInventario, setisIventatioCollapsed] = useState(true);
    const [isPrevencion, setisPrevencionCollapsed] = useState(true);
    const [isLogistica, setisLogisticaCollapsed] = useState(true);
    const [isContabilidadCollapsed, setIsContabilidadCollapsed] = useState(true);
    const [isAdministracionCollapsed, setIsAdministracionCollapsed] = useState(true);

    const toggleCollapse = (collapseSetter) => {
        collapseSetter(prev => !prev);
    };

    const getEmpresaName = (card) => getEmpresaByCodigo(card).nombre;

    // Estados para el formulario de orden de compra
    const [numeroOrden, setNumeroOrden] = useState("");
    const [fechaOrden, setFechaOrden] = useState(new Date().toISOString().split('T')[0]);
    const [senores, setSenores] = useState("");
    const [rutProveedor, setRutProveedor] = useState("");
    const [comuna, setComuna] = useState("");
    const [ciudad, setCiudad] = useState("");
    const [direccion, setDireccion] = useState("");
    const [telefono, setTelefono] = useState("");
    const [emisorNombre, setEmisorNombre] = useState("");
    const [emisorRut, setEmisorRut] = useState("");
    const [prioridad, setPrioridad] = useState("Normal");
    const [tipoTrabajo, setTipoTrabajo] = useState("Servicios");
    const [observaciones, setObservaciones] = useState("");

    // Estados para los detalles de la orden
    const [detalles, setDetalles] = useState([
        {
            item: 1,
            descripcion: "",
            valorUnitario: 0,
            cantidad: 1,
            subtotal: 0,
            iva: 0,
            valorTotal: 0
        }
    ]);    // Estados para las firmas
    const [firmas, setFirmas] = useState({
        emisor: { nombre: "", fecha: null },
        vbDeptoJmant: { nombre: "", fecha: null },
        vbJefeAdministrativo: { nombre: "", fecha: null },
        vbAdministrador: { nombre: "", fecha: null },
        recepcionConforme: { nombre: "", fecha: null }
    });

    // Estados para control
    const [listadoOrdenes, setListadoOrdenes] = useState([]);
    const [editar, setEditar] = useState(false);
    const [idOrdenSeleccionada, setIdOrdenSeleccionada] = useState("");

    // Estados para los modales de factura y comprobante de pago
    const [modalFacturaOpen, setModalFacturaOpen] = useState(false);
    const [modalComprobantePagoOpen, setModalComprobantePagoOpen] = useState(false);
    const [proveedores, setProveedores] = useState([]);
    const [mostrarProveedores, setMostrarProveedores] = useState(false);


    const [ordenParaCompletar, setOrdenParaCompletar] = useState(null);

    const empresa = getEmpresaName(cookies.selectedCard);

    // Función para agregar nueva fila de detalle
    const agregarDetalle = () => {
        const nuevoDetalle = {
            item: detalles.length + 1,
            descripcion: "",
            valorUnitario: 0,
            cantidad: 1,
            subtotal: 0,
            iva: 0,
            valorTotal: 0
        };
        setDetalles([...detalles, nuevoDetalle]);
    };

    // Función para actualizar detalle
    const actualizarDetalle = async (index, campo, valor) => {
        const nuevosDetalles = [...detalles];

        // Si el usuario está tratando de modificar el IVA manualmente
        if (campo === 'iva') {
            const valorUnitario = parseFloat(nuevosDetalles[index].valorUnitario) || 0;
            const cantidad = parseInt(nuevosDetalles[index].cantidad) || 0;
            const subtotalCalculado = valorUnitario * cantidad;
            const ivaCalculado = Math.round(subtotalCalculado * 0.19);

            // Mostrar alerta con cálculo detallado
            const result = await Swal.fire({
                title: '⚠️ Modificación de IVA',
                html: `
                    <div style="text-align: left; margin: 20px 0;">
                        <p><strong>¿Está seguro que desea modificar el IVA manualmente?</strong></p>
                        <hr>
                        <p><strong>Cálculo automático actual:</strong></p>
                        <ul style="margin: 10px 0; padding-left: 20px;">
                            <li>Valor Unitario: $${valorUnitario.toLocaleString('es-CL')}</li>
                            <li>Cantidad: ${cantidad}</li>
                            <li>Subtotal: $${subtotalCalculado.toLocaleString('es-CL')}</li>
                            <li>IVA (19%): $${ivaCalculado.toLocaleString('es-CL')}</li>
                        </ul>
                        <p><strong>Fórmula:</strong> (Valor Unitario × Cantidad) × 0.19</p>
                        <p style="color: #856404; background: #fff3cd; padding: 10px; border-radius: 5px; margin-top: 15px;">
                            <strong>Nota:</strong> El cálculo automático garantiza precisión matemática exacta.
                        </p>
                    </div>
                `,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, modificar manualmente',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                width: '500px'
            });

            if (!result.isConfirmed) {
                return; // No actualizar si el usuario cancela
            }
        }

        nuevosDetalles[index][campo] = valor;

        // Calcular automáticamente subtotal, IVA y total
        if (campo === 'valorUnitario' || campo === 'cantidad') {
            const valorUnitario = parseFloat(nuevosDetalles[index].valorUnitario) || 0;
            const cantidad = parseInt(nuevosDetalles[index].cantidad) || 0;

            nuevosDetalles[index].subtotal = valorUnitario * cantidad;
            nuevosDetalles[index].iva = Math.round(nuevosDetalles[index].subtotal * 0.19);
            nuevosDetalles[index].valorTotal = nuevosDetalles[index].subtotal + nuevosDetalles[index].iva;
        }

        // Si se modifica manualmente el IVA, recalcular solo el total
        if (campo === 'iva') {
            const subtotal = nuevosDetalles[index].subtotal || 0;
            const iva = parseFloat(valor) || 0;
            nuevosDetalles[index].valorTotal = subtotal + iva;
        }

        setDetalles(nuevosDetalles);
    };

    // Función para eliminar detalle
    const eliminarDetalle = (index) => {
        if (detalles.length > 1) {
            const nuevosDetalles = detalles.filter((_, i) => i !== index);
            // Reordenar items
            nuevosDetalles.forEach((detalle, i) => {
                detalle.item = i + 1;
            });
            setDetalles(nuevosDetalles);
        }
    };

    // Calcular totales
    const calcularSubtotal = () => {
        return detalles.reduce((sum, detalle) => sum + (parseFloat(detalle.subtotal) || 0), 0);
    };

    const calcularIVA = () => {
        return detalles.reduce((sum, detalle) => sum + (parseFloat(detalle.iva) || 0), 0);
    };

    const calcularTotal = () => {
        return detalles.reduce((sum, detalle) => sum + (parseFloat(detalle.valorTotal) || 0), 0);
    };



    // Función para obtener el próximo número de orden automático
    const obtenerProximoNumeroOrden = async () => {
        try {
            const response = await Axios.get(`${config.API_URL}/proximo-numero-orden/${cookiesEmpresa.idEmpresa}`);
            if (response.data.success) {
                return response.data.numeroOrden;
            } else {
                console.error('Error al obtener próximo número de orden:', response.data.error);
                return '0001'; // Valor por defecto con 4 dígitos
            }
        } catch (error) {
            console.error('Error al obtener próximo número de orden:', error);
            return '0001'; // Valor por defecto con 4 dígitos
        }
    };

    // Función para generar número de orden automático (función legacy - se mantiene por compatibilidad)
    const generarNumeroOrden = () => {
        const fecha = new Date();
        const año = fecha.getFullYear();
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const random = Math.floor(Math.random() * 10000);
        return `${año}${mes}${random}`;
    };

    // Función para limpiar formulario
    const limpiarFormulario = async () => {
        // Obtener el próximo número de orden automáticamente
        const proximoNumero = await obtenerProximoNumeroOrden();
        setNumeroOrden(proximoNumero);
        setFechaOrden(new Date().toISOString().split('T')[0]);
        setSenores("");
        setRutProveedor("");
        setComuna("");
        setCiudad("");
        setDireccion("");
        setTelefono("");
        setEmisorNombre("");
        setEmisorRut("");
        setPrioridad("Normal");
        setTipoTrabajo("Servicios");
        setObservaciones("");
        setDetalles([{
            item: 1,
            descripcion: "",
            valorUnitario: 0,
            cantidad: 1,
            subtotal: 0,
            iva: 0,
            valorTotal: 0
        }]);
        setFirmas({
            emisor: { nombre: "", fecha: null },
            vbDeptoJmant: { nombre: "", fecha: null },
            vbJefeAdministrativo: { nombre: "", fecha: null },
            vbAdministrador: { nombre: "", fecha: null },
            recepcionConforme: { nombre: "", fecha: null }
        });
        setEditar(false);
        setIdOrdenSeleccionada("");
    };

    // Función para cargar proveedores existentes
    const cargarProveedores = async () => {
        try {
            const response = await fetch(`http://localhost:3000/proveedores/${cookiesEmpresa.idEmpresa}`);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            if (data.success) {
                setProveedores(data.proveedores);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: data.error || 'Error desconocido al cargar proveedores'
                });
            }
        } catch (error) {
            console.error("Error al cargar proveedores:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudieron cargar los proveedores'
            });
        }
    };

    // Función para seleccionar un proveedor
    const seleccionarProveedor = (proveedor) => {
        setSenores(proveedor.Senores || "");
        setRutProveedor(proveedor.RUT_Proveedor || "");
        setComuna(proveedor.Comuna || "");
        setCiudad(proveedor.Ciudad || "");
        setDireccion(proveedor.Direccion || "");
        setTelefono(proveedor.Telefono || "");
        setMostrarProveedores(false);
    };

    // Función para alternar la visibilidad de proveedores
    const toggleProveedores = async () => {
        if (!mostrarProveedores && proveedores.length === 0) {
            await cargarProveedores();
        }
        setMostrarProveedores(!mostrarProveedores);
    };

    // Función para registrar orden de compra
    const registrarOrdenCompra = async (pedirAprobacionDespues = false) => {
        if (!senores || !rutProveedor || !direccion || !emisorNombre || !emisorRut) {
            Swal.fire({
                icon: 'warning',
                title: 'Campos Obligatorios',
                text: 'Por favor complete todos los campos obligatorios',
                confirmButtonColor: '#3085d6'
            });
            return;
        }

        // Validar formato de RUTs
        if (!validarRut(rutProveedor)) {
            Swal.fire({
                icon: 'error',
                title: 'RUT Inválido',
                text: 'El RUT del proveedor no es válido',
                confirmButtonColor: '#d33'
            });
            return;
        }

        if (!validarRut(emisorRut)) {
            Swal.fire({
                icon: 'error',
                title: 'RUT Inválido',
                text: 'El RUT del emisor no es válido',
                confirmButtonColor: '#d33'
            });
            return;
        }

        const ordenData = {
            numeroOrden: numeroOrden,
            fechaOrden: fechaOrden ? fechaOrden.split('T')[0] : new Date().toISOString().split('T')[0],
            senores,
            rutProveedor,
            comuna,
            ciudad,
            direccion,
            telefono,
            emisorNombre,
            emisorRut,
            prioridad,
            tipoTrabajo,
            idEmpresa: cookiesEmpresa.idEmpresa,
            usuarioCrea: cookies.usuario,
            observaciones,
            detalles,
            firmas
        };

        try {
            const response = await fetch(`${config.API_URL}/registrar-orden-compra`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(ordenData)
            });

            const result = await response.json();

            if (response.ok && result.success) {
                if (pedirAprobacionDespues) {
                    // Crear automáticamente la solicitud de aprobación
                    await crearSolicitudAprobacionAutomatica(result.idOrden, ordenData);

                    Swal.fire({
                        icon: 'success',
                        title: '¡Éxito!',
                        text: 'Orden de compra registrada y enviada para aprobación',
                        timer: 2000,
                        showConfirmButton: false
                    });
                } else {
                    Swal.fire({
                        icon: 'success',
                        title: '¡Éxito!',
                        text: 'Orden de compra registrada correctamente',
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
                limpiarFormulario();
                cargarOrdenes();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: result.message || 'Error al registrar la orden de compra',
                    confirmButtonColor: '#d33'
                });
            }
        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error de Conexión',
                text: 'No se pudo conectar con el servidor',
                confirmButtonColor: '#d33'
            });
        }
    };

    // Función para cargar órdenes
    const cargarOrdenes = async () => {
        try {
            const response = await fetch(`${config.API_URL}/ordenes-compra/${cookiesEmpresa.idEmpresa}`);
            if (response.ok) {
                const data = await response.json();
                setListadoOrdenes(data);
            }
        } catch (error) {
            console.error('Error al cargar órdenes:', error);
        }
    };

    // Función para obtener orden específica para editar
    const obtenerOrdenCompra = async (idOrden) => {
        try {
            const response = await fetch(`${config.API_URL}/orden-compra/${idOrden}`);
            if (response.ok) {
                const data = await response.json();
                const { orden, detalles } = data;

                // Cargar datos de la orden
                setNumeroOrden(orden.Numero_Orden);
                // Formatear fecha correctamente para input date
                const fechaFormateada = orden.Fecha_Orden ? new Date(orden.Fecha_Orden).toISOString().split('T')[0] : '';
                setFechaOrden(fechaFormateada);
                setSenores(orden.Senores);
                setRutProveedor(formatearRutEnTiempoReal(orden.RUT_Proveedor || ''));
                setComuna(orden.Comuna);
                setCiudad(orden.Ciudad);
                setDireccion(orden.Direccion);
                setTelefono(orden.Telefono || "");
                setEmisorNombre(orden.Emisor_Nombre);
                setEmisorRut(formatearRutEnTiempoReal(orden.Emisor_RUT || ''));
                setPrioridad(orden.Prioridad);
                setTipoTrabajo(orden.Tipo_Trabajo);
                setObservaciones(orden.Observaciones || "");

                // Cargar detalles
                if (detalles && detalles.length > 0) {
                    const detallesFormateados = detalles.map(detalle => {
                        const valorUnitario = parseFloat(detalle.Valor_Unitario) || 0;
                        const cantidad = parseInt(detalle.Cantidad) || 0;
                        const subtotal = valorUnitario * cantidad;
                        const iva = Math.round(subtotal * 0.19);
                        return {
                            item: detalle.Item,
                            descripcion: detalle.Descripcion,
                            valorUnitario: valorUnitario,
                            cantidad: cantidad,
                            subtotal: subtotal,
                            iva: iva,
                            valorTotal: subtotal + iva
                        };
                    });
                    setDetalles(detallesFormateados);
                } else {
                    // Si no hay detalles, mantener uno vacío
                    setDetalles([{
                        item: 1,
                        descripcion: "",
                        valorUnitario: 0,
                        cantidad: 1,
                        subtotal: 0,
                        iva: 0,
                        valorTotal: 0
                    }]);
                }

                // Verificar si la orden puede ser editada
                if (orden.Estado === 'Aprobada' || orden.Estado === 'Completada' || orden.Estado === 'Pagada') {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Orden no editable',
                        text: `No se puede editar una orden con estado "${orden.Estado}". Solo se pueden editar órdenes Pendientes.`,
                        confirmButtonColor: '#d33'
                    });
                    return;
                }

                // Activar modo edición
                setEditar(true);
                setIdOrdenSeleccionada(idOrden);

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al cargar la orden',
                    confirmButtonColor: '#d33'
                });
            }
        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error de Conexión',
                text: 'No se pudo conectar con el servidor al cargar la orden',
                confirmButtonColor: '#d33'
            });
        }
    };

    // Función para actualizar orden de compra
    const actualizarOrdenCompra = async () => {
        if (!senores || !rutProveedor || !direccion || !emisorNombre || !emisorRut) {
            Swal.fire({
                icon: 'warning',
                title: 'Campos Obligatorios',
                text: 'Por favor complete todos los campos obligatorios',
                confirmButtonColor: '#3085d6'
            });
            return;
        }

        // Validar formato de RUTs
        if (!validarRut(rutProveedor)) {
            Swal.fire({
                icon: 'error',
                title: 'RUT Inválido',
                text: 'El RUT del proveedor no es válido',
                confirmButtonColor: '#d33'
            });
            return;
        }

        if (!validarRut(emisorRut)) {
            Swal.fire({
                icon: 'error',
                title: 'RUT Inválido',
                text: 'El RUT del emisor no es válido',
                confirmButtonColor: '#d33'
            });
            return;
        }

        const ordenData = {
            numeroOrden,
            fechaOrden: fechaOrden ? fechaOrden.split('T')[0] : new Date().toISOString().split('T')[0],
            senores,
            rutProveedor,
            comuna,
            ciudad,
            direccion,
            telefono,
            emisorNombre,
            emisorRut,
            prioridad,
            tipoTrabajo,
            observaciones,
            detalles,
            estado: 'Pendiente'
        };

        try {
            const response = await fetch(`${config.API_URL}/actualizar-orden-compra/${idOrdenSeleccionada}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(ordenData)
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: '¡Actualizado!',
                    text: 'Orden de compra actualizada exitosamente',
                    timer: 2000,
                    showConfirmButton: false
                });
                limpiarFormulario();
                cargarOrdenes();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al actualizar la orden de compra',
                    confirmButtonColor: '#d33'
                });
            }
        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error de Conexión',
                text: 'No se pudo conectar con el servidor',
                confirmButtonColor: '#d33'
            });
        }
    };

    // Función para clonar orden de compra
    const clonarOrdenCompra = async (idOrden) => {
        try {
            const response = await fetch(`${config.API_URL}/orden-compra/${idOrden}`);
            if (response.ok) {
                const data = await response.json();
                const { orden, detalles } = data;

                // Cargar datos de la orden pero con nuevo número automático
                const proximoNumero = await obtenerProximoNumeroOrden();
                setNumeroOrden(proximoNumero);
                setFechaOrden(new Date().toISOString().split('T')[0]);
                setSenores(orden.Senores);
                setRutProveedor(formatearRutEnTiempoReal(orden.RUT_Proveedor || ''));
                setComuna(orden.Comuna);
                setCiudad(orden.Ciudad);
                setDireccion(orden.Direccion);
                setTelefono(orden.Telefono || "");
                setEmisorNombre(orden.Emisor_Nombre);
                setEmisorRut(formatearRutEnTiempoReal(orden.Emisor_RUT || ''));
                setPrioridad(orden.Prioridad);
                setTipoTrabajo(orden.Tipo_Trabajo);
                setObservaciones(orden.Observaciones || "");

                // Cargar detalles
                if (detalles && detalles.length > 0) {
                    const detallesFormateados = detalles.map((detalle, index) => {
                        const valorUnitario = parseFloat(detalle.Valor_Unitario) || 0;
                        const cantidad = parseInt(detalle.Cantidad) || 0;
                        const subtotal = valorUnitario * cantidad;
                        const iva = Math.round(subtotal * 0.19);
                        return {
                            item: index + 1,
                            descripcion: detalle.Descripcion,
                            valorUnitario: valorUnitario,
                            cantidad: cantidad,
                            subtotal: subtotal,
                            iva: iva,
                            valorTotal: subtotal + iva
                        };
                    });
                    setDetalles(detallesFormateados);
                }

                // No activar modo edición (será una nueva orden)
                setEditar(false);
                setIdOrdenSeleccionada("");

                Swal.fire({
                    icon: 'success',
                    title: '¡Orden Clonada!',
                    text: 'Orden clonada exitosamente. Modifique los datos según necesite.',
                    confirmButtonColor: '#3085d6'
                });

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al clonar la orden',
                    confirmButtonColor: '#d33'
                });
            }
        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error de Conexión',
                text: 'No se pudo conectar con el servidor al clonar la orden',
                confirmButtonColor: '#d33'
            });
        }
    };

    // Función para eliminar orden
    const eliminarOrden = async (id) => {
        const result = await Swal.fire({
            title: '¿Está seguro?',
            text: "¿Desea eliminar esta orden de compra?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                const response = await fetch(`${config.API_URL}/eliminar-orden-compra/${id}`, {
                    method: 'DELETE'
                });

                if (response.ok) {
                    Swal.fire({
                        icon: 'success',
                        title: '¡Eliminado!',
                        text: 'Orden eliminada exitosamente',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    cargarOrdenes();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al eliminar la orden',
                        confirmButtonColor: '#d33'
                    });
                }
            } catch (error) {
                console.error('Error:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error de Conexión',
                    text: 'No se pudo conectar con el servidor',
                    confirmButtonColor: '#d33'
                });
            }
        }
    };

    // Función para pedir aprobación de orden de compra
    const pedirAprobacionOrden = async () => {
        try {
            // Validar que todos los campos requeridos estén completos
            if (!numeroOrden || !senores || !rutProveedor || !emisorNombre || detalles.length === 0) {
                Swal.fire(
                    'Información incompleta',
                    'Por favor completa todos los campos requeridos antes de solicitar aprobación',
                    'warning'
                );
                return;
            }

            // Verificar que la orden esté guardada
            if (!idOrdenSeleccionada) {
                const result = await Swal.fire({
                    title: 'Orden no guardada',
                    text: 'Para poder solicitar aprobación, primero debes guardar la orden de compra. ¿Qué deseas hacer?',
                    icon: 'warning',
                    showCancelButton: true,
                    showDenyButton: true,
                    confirmButtonColor: '#28a745',
                    cancelButtonColor: '#6c757d',
                    denyButtonColor: '#d33',
                    confirmButtonText: 'Registrar orden y pedir aprobación',
                    cancelButtonText: 'Cancelar solicitud de aprobación',
                    denyButtonText: 'Solo registrar orden'
                });

                if (result.isConfirmed) {
                    // Guardar orden y luego pedir aprobación
                    await registrarOrdenCompra(true); // Pasar parámetro para indicar que se debe pedir aprobación después
                    return;
                } else if (result.isDenied) {
                    // Solo guardar la orden
                    await registrarOrdenCompra(false);
                    return;
                } else {
                    // Cancelar
                    return;
                }
            }

            // Verificar si ya existe una solicitud de aprobación para esta orden
            const verificarSolicitudResponse = await Axios.get(`${config.API_URL}/verificarSolicitudExistente/${idOrdenSeleccionada}`);

            if (verificarSolicitudResponse.data.exists) {
                Swal.fire(
                    'Solicitud ya enviada',
                    'Ya existe una solicitud de aprobación pendiente para esta orden de compra',
                    'info'
                );
                return;
            }

            const solicitudData = {
                ID_Empresa: cookiesEmpresa.idEmpresa,
                Modulo: 'OrdenCompras',
                Tipo_Solicitud: 'Aprobacion_Orden_Compra',
                Usuario_Crea: cookies.usuario,
                Observacion: `Solicitud de aprobación para Orden de Compra N° ${numeroOrden} - Proveedor: ${senores} - Total: $${formatRemuneracion(calcularTotal())}`,
                ID_Referencia: idOrdenSeleccionada // ID de la orden de compra
            };

            const response = await Axios.post(`${config.API_URL}/crearSolicitudAprobacion`, solicitudData);

            if (response.data.success) {
                // Cambiar estado de la orden a "Enviada" cuando se envía para aprobación
                await Axios.put(`${config.API_URL}/cambiarEstadoOrden`, {
                    idOrden: idOrdenSeleccionada,
                    nuevoEstado: 'Enviada',
                    usuario: cookies.usuario
                });

                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'OrdenCompras',
                    Detalle: `Solicitud de aprobación enviada para Orden N° ${numeroOrden} - Estado cambiado a Enviada`,
                    Estado: 'Éxito',
                });

                Swal.fire(
                    '¡Solicitud enviada!',
                    'La solicitud de aprobación ha sido enviada correctamente',
                    'success'
                );

                // Limpiar formulario después de enviar solicitud
                limpiarFormulario();
                cargarOrdenes();
            }
        } catch (error) {
            console.error('Error al enviar solicitud de aprobación:', error);

            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'OrdenCompras',
                Detalle: `Error al enviar solicitud de aprobación para Orden N° ${numeroOrden} - Error: ${error.message}`,
                Estado: 'Fallo',
            });

            Swal.fire(
                'Error',
                'Hubo un error al enviar la solicitud de aprobación',
                'error'
            );
        }
    };

    // Función para crear solicitud de aprobación automáticamente
    const crearSolicitudAprobacionAutomatica = async (idOrden, ordenData) => {
        try {
            const solicitudData = {
                ID_Empresa: cookiesEmpresa.idEmpresa,
                Modulo: 'OrdenCompras',
                Tipo_Solicitud: 'Aprobacion_Orden_Compra',
                Usuario_Crea: cookies.usuario,
                Observacion: `Solicitud de aprobación para Orden de Compra N° ${ordenData.numeroOrden} - Proveedor: ${ordenData.senores} - Total: $${formatRemuneracion(calcularTotal())}`,
                ID_Referencia: idOrden
            };

            await Axios.post(`${config.API_URL}/crearSolicitudAprobacion`, solicitudData);

            // Cambiar estado de la orden a "Enviada" cuando se envía para aprobación
            await Axios.put(`${config.API_URL}/cambiarEstadoOrden`, {
                idOrden,
                nuevoEstado: 'Enviada',
                usuario: cookies.usuario
            });

            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'OrdenCompras',
                Detalle: `Solicitud de aprobación creada automáticamente para Orden N° ${ordenData.numeroOrden} - Estado cambiado a Enviada`,
                Estado: 'Éxito',
            });
        } catch (error) {
            console.error('Error al crear solicitud de aprobación automática:', error);
        }
    };

    // Función para cambiar estado de orden manualmente
    const cambiarEstadoOrden = async (idOrden, estadoActual, numeroOrden) => {
        if (estadoActual === 'Aprobada') {
            // Buscar la orden completa en el listado
            const ordenCompleta = listadoOrdenes.find(orden => orden.ID_Orden === idOrden);

            // Agregar el usuario actual a los datos de la orden
            const ordenConUsuario = {
                ...ordenCompleta,
                usuario: cookies.usuario
            };

            setOrdenParaCompletar(ordenConUsuario);
            setModalFacturaOpen(true);
        } else if (estadoActual === 'Completada') {
            // Buscar la orden completa en el listado
            const ordenCompleta = listadoOrdenes.find(orden => orden.ID_Orden === idOrden);

            // Agregar el usuario actual a los datos de la orden
            const ordenConUsuario = {
                ...ordenCompleta,
                usuario: cookies.usuario
            };

            setOrdenParaCompletar(ordenConUsuario);
            setModalComprobantePagoOpen(true);
        }
    };

    // Función para manejar el éxito del modal de factura
    const handleFacturaSuccess = () => {
        cargarOrdenes(); // Recargar la lista de órdenes
        setModalFacturaOpen(false);
        setOrdenParaCompletar(null);
    };

    // Función para manejar el éxito del modal de comprobante de pago
    const handleComprobantePagoSuccess = () => {
        cargarOrdenes(); // Recargar la lista de órdenes
        setModalComprobantePagoOpen(false);
        setOrdenParaCompletar(null);
    };

    // Función para descargar factura
    const descargarFactura = async (idArchivo, numeroOrden) => {
        try {
            const response = await fetch(`${config.API_URL}/descargarFactura/${idArchivo}`);

            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = `Factura_Orden_${numeroOrden}.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);

                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'OrdenCompras',
                    Detalle: `Factura descargada para Orden N° ${numeroOrden}`,
                    Estado: 'Éxito',
                });
            } else {
                throw new Error('Error al descargar el archivo');
            }
        } catch (error) {
            console.error('Error al descargar factura:', error);
            Swal.fire('Error', 'No se pudo descargar la factura', 'error');
        }
    };

    // Función para descargar comprobante de pago
    const descargarComprobantePago = async (idArchivo, numeroOrden) => {
        try {
            const response = await fetch(`${config.API_URL}/descargarComprobantePago/${idArchivo}`);

            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = `Comprobante_Pago_Orden_${numeroOrden}.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);

                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'OrdenCompras',
                    Detalle: `Comprobante de pago descargado para Orden N° ${numeroOrden}`,
                    Estado: 'Éxito',
                });
            } else {
                throw new Error('Error al descargar el archivo');
            }
        } catch (error) {
            console.error('Error al descargar comprobante de pago:', error);
            Swal.fire('Error', 'No se pudo descargar el comprobante de pago', 'error');
        }
    };

    // Manejar otros estados (código existente)
    const cambiarEstadoOrdenOtros = async (idOrden, estadoActual, numeroOrden) => {
        if (estadoActual === 'Pendiente') {
            const result = await Swal.fire({
                title: '¿Rechazar orden de compra?',
                text: `Estás a punto de cambiar el estado de la orden ${numeroOrden} de 'Pendiente' a 'RECHAZADA'. Esta acción marcará la orden como rechazada.`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Sí, rechazar',
                cancelButtonText: 'Cancelar'
            });

            if (result.isConfirmed) {
                try {
                    const response = await Axios.put(`${config.API_URL}/cambiarEstadoOrden`, {
                        idOrden,
                        nuevoEstado: 'RECHAZADA',
                        usuario: cookies.usuario
                    });

                    if (response.data.success) {
                        await registrarLog({
                            Usuario: cookies.usuario,
                            Modulo: 'OrdenCompras',
                            Detalle: `Estado de orden ${numeroOrden} cambiado a RECHAZADA`,
                            Estado: 'Éxito',
                        });

                        Swal.fire(
                            '¡Estado actualizado!',
                            `La orden ${numeroOrden} ha sido marcada como rechazada.`,
                            'success'
                        );

                        cargarOrdenes();
                    }
                } catch (error) {
                    console.error('Error al cambiar estado:', error);

                    await registrarLog({
                        Usuario: cookies.usuario,
                        Modulo: 'OrdenCompras',
                        Detalle: `Error al cambiar estado de orden ${numeroOrden} - Error: ${error.message}`,
                        Estado: 'Fallo',
                    });

                    Swal.fire(
                        'Error',
                        'Hubo un error al cambiar el estado de la orden',
                        'error'
                    );
                }
            }
        }
    };

    // Función para descargar PDF de orden específica
    const descargarPDFOrden = async (orden) => {
        try {
            // Obtener detalles de la orden
            const response = await fetch(`${config.API_URL}/orden-compra-detalle/${orden.ID_Orden}`);
            const ordenCompleta = await response.json();

            if (ordenCompleta.success) {
                const { orden: datosOrden, detalles } = ordenCompleta;

                // Generar PDF con los datos completos
                generarOrdenCompraPDF({
                    numeroOrden: datosOrden.Numero_Orden,
                    fechaOrden: datosOrden.Fecha_Orden,
                    senores: datosOrden.Senores,
                    rutProveedor: datosOrden.RUT_Proveedor,
                    comuna: datosOrden.Comuna,
                    ciudad: datosOrden.Ciudad,
                    direccion: datosOrden.Direccion,
                    telefono: datosOrden.Telefono,
                    emisorNombre: datosOrden.Emisor_Nombre,
                    emisorRut: datosOrden.Emisor_RUT,
                    usuarioCreador: datosOrden.Usuario_Crea, // Usuario que creó la orden
                    usuarioAprueba: datosOrden.Usuario_Aprueba, // Usuario que aprobó la orden
                    prioridad: datosOrden.Prioridad,
                    tipoTrabajo: datosOrden.Tipo_Trabajo,
                    detalles: detalles,
                    subtotal: datosOrden.Subtotal,
                    iva: datosOrden.IVA,
                    total: datosOrden.Total,
                    empresa,
                    selectedCard: cookies.selectedCard,
                    observaciones: datosOrden.Observaciones
                });

                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'OrdenCompras',
                    Detalle: `PDF descargado para Orden N° ${datosOrden.Numero_Orden}`,
                    Estado: 'Éxito',
                });
            }
        } catch (error) {
            console.error('Error al descargar PDF:', error);
            Swal.fire(
                'Error',
                'No se pudo descargar el PDF de la orden',
                'error'
            );
        }
    };

    // Cargar datos al inicializar
    useEffect(() => {
        const inicializarDatos = async () => {
            await cargarOrdenes();
            // Obtener próximo número de orden automático
            const proximoNumero = await obtenerProximoNumeroOrden();
            setNumeroOrden(proximoNumero);
        };

        inicializarDatos();
    }, [cookiesEmpresa.idEmpresa]);

    return (
        <body id="page-top">
            <div id="wrapper">
                <Sidebar
                    imageUrl={imageUrl}
                    cookies={cookies}
                    isComponentsCollapsed={isComponentsCollapsed}
                    toggleCollapse={toggleCollapse}
                    setIsComponentsCollapsed={setIsComponentsCollapsed}
                    isUtilitiesCollapsed={isUtilitiesCollapsed}
                    setIsUtilitiesCollapsed={setIsUtilitiesCollapsed}
                    isInventario={isInventario}
                    setisIventatioCollapsed={setisIventatioCollapsed}
                    isPrevencion={isPrevencion}
                    setisPrevencionCollapsed={setisPrevencionCollapsed}
                    isLogistica={isLogistica}
                    setisLogisticaCollapsed={setisLogisticaCollapsed}
                    isContabilidadCollapsed={isContabilidadCollapsed}
                    setIsContabilidadCollapsed={setIsContabilidadCollapsed}
                    isAdministracionCollapsed={isAdministracionCollapsed}
                    setIsAdministracionCollapsed={setIsAdministracionCollapsed}
                />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card shadow mb-4">
                                        <div className="card-header py-3">
                                            <h6 className="m-0 font-weight-bold text-primary">
                                                Crear Orden de Compra - {empresa}
                                            </h6>
                                        </div>
                                        <div className="card-body">
                                            {/* Información de la orden */}
                                            <div className="orden-header">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="input-group mb-3">
                                                            <span className="input-group-text">N° Orden</span>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={numeroOrden}
                                                                placeholder="Número automático"
                                                                readOnly
                                                                style={{ backgroundColor: '#f8f9fa', cursor: 'not-allowed' }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="input-group mb-3">
                                                            <span className="input-group-text">Fecha</span>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                value={fechaOrden}
                                                                onChange={(e) => setFechaOrden(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Información del proveedor */}
                                            <div className="proveedor-section">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h5>Información del Proveedor</h5>
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-info btn-sm"
                                                        onClick={toggleProveedores}
                                                        title="Seleccionar proveedor existente"
                                                    >
                                                        <i className="fas fa-address-book mr-1"></i>
                                                        Proveedores
                                                    </button>
                                                </div>

                                                {/* Lista de proveedores */}
                                                {mostrarProveedores && (
                                                    <div className="card mb-3">
                                                        <div className="card-header">
                                                            <h6 className="mb-0">Seleccionar Proveedor</h6>
                                                        </div>
                                                        <div className="card-body" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                                            {proveedores.length > 0 ? (
                                                                proveedores.map((proveedor, index) => (
                                                                    <div
                                                                        key={index}
                                                                        className="border p-2 mb-2 cursor-pointer hover-bg-light"
                                                                        style={{ cursor: 'pointer', borderRadius: '4px' }}
                                                                        onClick={() => seleccionarProveedor(proveedor)}
                                                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                                                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                                                    >
                                                                        <strong>{proveedor.Senores}</strong><br />
                                                                        <small className="text-muted">
                                                                            RUT: {proveedor.RUT_Proveedor} |
                                                                            {proveedor.Ciudad && ` ${proveedor.Ciudad}`}
                                                                            {proveedor.Comuna && `, ${proveedor.Comuna}`}
                                                                        </small>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <p className="text-muted mb-0">No hay proveedores registrados</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="row">

                                                    <div className="col-md-8">
                                                        <div className="input-group mb-3">
                                                            <span className="input-group-text">Señor(es)</span>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={senores}
                                                                onChange={(e) => setSenores(e.target.value)}
                                                                placeholder="Nombre del proveedor"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="input-group mb-3">
                                                            <span className="input-group-text">RUT</span>
                                                            <input
                                                                type="text"
                                                                className={`form-control ${rutProveedor && !validarRut(rutProveedor) ? 'is-invalid' : ''}`}
                                                                value={rutProveedor}
                                                                onChange={(e) => setRutProveedor(formatearRutEnTiempoReal(e.target.value))}
                                                                placeholder="12.345.678-9"
                                                            />
                                                        </div>
                                                        {rutProveedor && !validarRut(rutProveedor) && (
                                                            <div className="rut-validation-message">
                                                                <small>El RUT ingresado no es válido</small>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="input-group mb-3">
                                                            <span className="input-group-text">Comuna</span>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={comuna}
                                                                onChange={(e) => setComuna(e.target.value)}
                                                                placeholder="Comuna"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="input-group mb-3">
                                                            <span className="input-group-text">Ciudad</span>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={ciudad}
                                                                onChange={(e) => setCiudad(e.target.value)}
                                                                placeholder="Ciudad"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-8">
                                                        <div className="input-group mb-3">
                                                            <span className="input-group-text">Dirección</span>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={direccion}
                                                                onChange={(e) => setDireccion(e.target.value)}
                                                                placeholder="Dirección completa"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="input-group mb-3">
                                                            <span className="input-group-text">Teléfono</span>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={telefono}
                                                                onChange={(e) => setTelefono(e.target.value)}
                                                                placeholder="Teléfono"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Información del emisor */}
                                            <div className="emisor-section">
                                                <h5>Información del Emisor</h5>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="input-group mb-3">
                                                            <span className="input-group-text">Emisor</span>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={emisorNombre}
                                                                onChange={(e) => setEmisorNombre(e.target.value)}
                                                                placeholder="Nombre del emisor"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="input-group mb-3">
                                                            <span className="input-group-text">RUT Emisor</span>
                                                            <input
                                                                type="text"
                                                                className={`form-control ${emisorRut && !validarRut(emisorRut) ? 'is-invalid' : ''}`}
                                                                value={emisorRut}
                                                                onChange={(e) => setEmisorRut(formatearRutEnTiempoReal(e.target.value))}
                                                                placeholder="12.345.678-9"
                                                            />
                                                        </div>
                                                        {emisorRut && !validarRut(emisorRut) && (
                                                            <div className="rut-validation-message">
                                                                <small>El RUT ingresado no es válido</small>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="input-group mb-3">
                                                            <span className="input-group-text">Prioridad</span>
                                                            <select
                                                                className="form-control"
                                                                value={prioridad}
                                                                onChange={(e) => setPrioridad(e.target.value)}
                                                            >
                                                                <option value="Normal">Normal</option>
                                                                <option value="Urgente">Urgente</option>
                                                                <option value="Crítica">Crítica</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="input-group mb-3">
                                                            <span className="input-group-text">Tipo</span>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={tipoTrabajo}
                                                                onChange={(e) => setTipoTrabajo(e.target.value)}
                                                                placeholder="Tipo de trabajo"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Descripción del trabajo */}
                                            <div className="trabajo-section">
                                                <h5>Descripción del Trabajo</h5>
                                                <div className="table-responsive">
                                                    <table className="table table-bordered detalle-table">
                                                        <thead>
                                                            <tr>
                                                                <th width="5%">N</th>
                                                                <th width="40%">Descripción</th>
                                                                <th width="12%">Valor Unitario</th>
                                                                <th width="8%">Cantidad</th>
                                                                <th width="12%">Subtotal</th>
                                                                <th width="12%">IVA (19%)</th>
                                                                <th width="12%">Total</th>
                                                                <th width="5%">Acciones</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {detalles.map((detalle, index) => (
                                                                <tr key={index}>
                                                                    <td>{detalle.item}</td>
                                                                    <td>
                                                                        <textarea
                                                                            className="form-control"
                                                                            value={detalle.descripcion}
                                                                            onChange={(e) => actualizarDetalle(index, 'descripcion', e.target.value)}
                                                                            placeholder="Descripción del servicio/producto"
                                                                            rows="2"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={detalle.valorUnitario}
                                                                            onChange={(e) => actualizarDetalle(index, 'valorUnitario', e.target.value)}
                                                                            placeholder="0"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={detalle.cantidad}
                                                                            onChange={(e) => actualizarDetalle(index, 'cantidad', e.target.value)}
                                                                            placeholder="1"
                                                                            min="1"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <strong className="text-primary">
                                                                            ${formatRemuneracion(detalle.subtotal || 0)}
                                                                        </strong>
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control text-center"
                                                                            value={detalle.iva || 0}
                                                                            onChange={(e) => actualizarDetalle(index, 'iva', e.target.value)}
                                                                            placeholder="0"
                                                                            style={{ backgroundColor: '#f8f9fa' }}
                                                                        />
                                                                        <small className="text-muted">
                                                                            Auto: ${formatRemuneracion(Math.round((detalle.subtotal || 0) * 0.19))}
                                                                        </small>
                                                                    </td>
                                                                    <td>
                                                                        <strong className="text-success">
                                                                            ${formatRemuneracion(detalle.valorTotal || 0)}
                                                                        </strong>
                                                                    </td>
                                                                    <td>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-danger btn-sm"
                                                                            onClick={() => eliminarDetalle(index)}
                                                                            disabled={detalles.length === 1}
                                                                        >
                                                                            <i className="fas fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary mb-3"
                                                    onClick={agregarDetalle}
                                                >
                                                    Agregar Ítem
                                                </button>
                                            </div>

                                            {/* Totales */}
                                            <div className="totales-section">
                                                <div className="row justify-content-end">
                                                    <div className="col-md-4">
                                                        <table className="table table-sm">
                                                            <tbody>
                                                                <tr>
                                                                    <td><strong>NETO</strong></td>
                                                                    <td className="text-right">
                                                                        ${formatRemuneracion(calcularSubtotal())}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>IVA</strong></td>
                                                                    <td className="text-right">
                                                                        ${formatRemuneracion(calcularIVA())}
                                                                    </td>
                                                                </tr>
                                                                <tr className="table-primary">
                                                                    <td><strong>TOTAL</strong></td>
                                                                    <td className="text-right">
                                                                        <strong>${formatRemuneracion(calcularTotal())}</strong>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Observaciones */}
                                            <div className="observaciones-section">
                                                <div className="input-group mb-3">
                                                    <span className="input-group-text">Observaciones</span>
                                                    <textarea
                                                        className="form-control"
                                                        value={observaciones}
                                                        onChange={(e) => setObservaciones(e.target.value)}
                                                        placeholder="Observaciones adicionales"
                                                        rows="3"
                                                    />
                                                </div>
                                            </div>

                                            {/* Botones de acción */}
                                            <div className="acciones-section">
                                                <div className="btn-group" role="group">
                                                    {editar && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-success"
                                                            onClick={actualizarOrdenCompra}
                                                        >
                                                            Actualizar Orden
                                                        </button>
                                                    )}
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        onClick={limpiarFormulario}
                                                    >
                                                        Limpiar
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-warning"
                                                        onClick={pedirAprobacionOrden}
                                                        disabled={!numeroOrden || detalles.length === 0}
                                                        title="Pedir aprobación de la orden"
                                                    >
                                                        Pedir Aprobación
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Lista de órdenes */}
                                <div className="col-lg-12">
                                    <div className="card shadow mb-4">
                                        <div className="card-header py-3">
                                            <h6 className="m-0 font-weight-bold text-primary">
                                                Listado de Órdenes de Compra
                                            </h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered" width="100%">
                                                    <thead>
                                                        <tr>
                                                            <th>N° Orden</th>
                                                            <th>Fecha</th>
                                                            <th>Proveedor</th>
                                                            <th>RUT</th>
                                                            <th>Emisor</th>
                                                            <th>Estado</th>
                                                            <th>Total</th>
                                                            <th>Acciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Array.isArray(listadoOrdenes) && listadoOrdenes.length > 0 ? (
                                                            listadoOrdenes.map((orden, index) => (
                                                                <tr key={index}>
                                                                    <td>{orden.Numero_Orden}</td>
                                                                    <td>{moment(orden.Fecha_Orden).format('DD/MM/YYYY')}</td>
                                                                    <td>{orden.Senores}</td>
                                                                    <td>{orden.RUT_Proveedor}</td>
                                                                    <td>{orden.Emisor_Nombre}</td>
                                                                    <td>
                                                                        {orden.Estado === 'Aprobada' ? (
                                                                            <span
                                                                                className="badge badge-success"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => cambiarEstadoOrden(orden.ID_Orden, orden.Estado, orden.Numero_Orden)}
                                                                                title="Click para subir factura y completar"
                                                                            >
                                                                                {orden.Estado} ✓
                                                                            </span>
                                                                        ) : orden.Estado === 'Completada' ? (
                                                                            <span
                                                                                className="badge badge-primary"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => cambiarEstadoOrden(orden.ID_Orden, orden.Estado, orden.Numero_Orden)}
                                                                                title="Click para subir comprobante de pago"
                                                                            >
                                                                                {orden.Estado} ✓
                                                                            </span>
                                                                        ) : orden.Estado === 'Pendiente' ? (
                                                                            <span
                                                                                className="badge badge-warning"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => cambiarEstadoOrden(orden.ID_Orden, orden.Estado, orden.Numero_Orden)}
                                                                                title="Click para rechazar orden"
                                                                            >
                                                                                {orden.Estado}
                                                                            </span>
                                                                        ) : (
                                                                            <span className={`badge badge-${orden.Estado === 'Pendiente' ? 'warning' :
                                                                                orden.Estado === 'Aprobada' ? 'success' :
                                                                                    (orden.Estado === 'Rechazada' || orden.Estado === 'RECHAZADA') ? 'danger' :
                                                                                        orden.Estado === 'Enviada' ? 'info' :
                                                                                            orden.Estado === 'Completada' ? 'primary' :
                                                                                                orden.Estado === 'Pagada' ? 'success' : 'secondary'
                                                                                }`}
                                                                                style={orden.Estado === 'Pagada' ? { backgroundColor: '#28a745', color: 'white', fontWeight: 'bold' } : {}}>
                                                                                {orden.Estado}
                                                                                {orden.Estado === 'Pagada' ? ' ✓✓' : ''}
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                    <td>${formatRemuneracion(orden.Total || 0)}</td>
                                                                    <td>
                                                                        <div className="btn-group">
                                                                            <button
                                                                                type="button"
                                                                                className={`btn btn-sm ${orden.Estado !== 'Pendiente' ? 'btn-secondary disabled' : 'btn-info'}`}
                                                                                onClick={() => orden.Estado === 'Pendiente' ? obtenerOrdenCompra(orden.ID_Orden) : null}
                                                                                title={orden.Estado !== 'Pendiente' ? `No se puede editar - Estado: ${orden.Estado}` : "Editar orden"}
                                                                                disabled={orden.Estado !== 'Pendiente'}
                                                                            >
                                                                                <i className="fas fa-edit"></i>
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-success btn-sm"
                                                                                onClick={() => clonarOrdenCompra(orden.ID_Orden)}
                                                                                title="Clonar orden"
                                                                            >
                                                                                <i className="fas fa-copy"></i>
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-danger btn-sm"
                                                                                onClick={() => eliminarOrden(orden.ID_Orden)}
                                                                                title="Eliminar orden"
                                                                            >
                                                                                <i className="fas fa-trash"></i>
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className={`btn btn-primary btn-sm ${(orden.Estado !== 'Aprobada' && orden.Estado !== 'Completada' && orden.Estado !== 'Pagada') ? 'disabled' : ''}`}
                                                                                onClick={() => (orden.Estado === 'Aprobada' || orden.Estado === 'Completada' || orden.Estado === 'Pagada') ? descargarPDFOrden(orden) : null}
                                                                                title={orden.Estado === 'Aprobada' || orden.Estado === 'Completada' || orden.Estado === 'Pagada' ? "Descargar PDF" : "PDF disponible solo para órdenes aprobadas"}
                                                                                disabled={orden.Estado !== 'Aprobada' && orden.Estado !== 'Completada' && orden.Estado !== 'Pagada'}
                                                                            >
                                                                                <i className="fas fa-file-pdf"></i>
                                                                            </button>
                                                                            {/* Botón de descarga de factura - solo visible si la orden está completada/pagada y tiene factura */}
                                                                            {(orden.Estado === 'Completada' || orden.Estado === 'Pagada') && orden.id_archivo_factura && (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-warning btn-sm"
                                                                                    onClick={() => descargarFactura(orden.id_archivo_factura, orden.Numero_Orden)}
                                                                                    title="Descargar Factura"
                                                                                >
                                                                                    <i className="fas fa-file-invoice"></i>
                                                                                </button>
                                                                            )}
                                                                            {/* Botón de descarga de comprobante de pago - solo visible si la orden está pagada y tiene comprobante */}
                                                                            {orden.Estado === 'Pagada' && orden.id_archivo_comprobante_pago && (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-info btn-sm"
                                                                                    onClick={() => descargarComprobantePago(orden.id_archivo_comprobante_pago, orden.Numero_Orden)}
                                                                                    title="Descargar Comprobante de Pago"
                                                                                >
                                                                                    <i className="fas fa-receipt"></i>
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="8" className="text-center">
                                                                    No hay órdenes de compra registradas
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal de Factura */}
            <ModalFactura
                isOpen={modalFacturaOpen}
                onClose={() => setModalFacturaOpen(false)}
                ordenData={ordenParaCompletar}
                onSuccess={handleFacturaSuccess}
            />

            {/* Modal de Comprobante de Pago */}
            <ModalComprobantePago
                isOpen={modalComprobantePagoOpen}
                onClose={() => setModalComprobantePagoOpen(false)}
                ordenData={ordenParaCompletar}
                onSuccess={handleComprobantePagoSuccess}
            />
        </body>
    );
}

export default OrdenCompras;